import type { Agency, ApprovalStatus, Image, Metrics } from 'types';

type AgencyProfileChannel = {
  type: string,
  url: string,
  username?: string | null,
  metrics: Metrics
};

export type AgencyProfile = {
  id: number,
  agencyDetails: Agency,
  approvalStatus: ApprovalStatus,
  artistName: string,
  channels: {
    instagram?: AgencyProfileChannel,
    tiktok?: AgencyProfileChannel
  },
  influencerFirstName: string,
  influencer_last_name: string,
  name: string,
  profileImage: Image
};

export enum AgencyProfilesLoadingState {
  initial,
  loading,
  loaded
}

export type AgencyProfilesReduxState = {
  profiles: Array<AgencyProfile>,
  loadingStatus: AgencyProfilesLoadingState
};
